import apontamentoColetasMatrizReport from "entity/Indicador/reports/ApontamentoColetasMatrizReport";
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import TableReportHelper from "report/helper";

export default async function ibfReport(indicador, visita) {
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const h = new TableReportHelper(apontamento);
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)

        content.push([
            await apontamentoHeaderLocalizacaoReport(visita, indicador, apontamento, params, "Infestação (%)"),
            apontamentoColetasMatrizReport(
                visita,
                indicador,
                apontamento,
                // TODO: unidade
                ["Entrenós", "Base", "Meio", "Ponta", "Brocados"],
                // prettier-ignore
                (h) => [
                    h.numberField("entrenos", { digits: 0 }),
                    h.numberField("base", { digits: 0 }),
                    h.numberField("meio", { digits: 0 }),
                    h.numberField("ponta", { digits: 0 }),
                    h.numberField("brocados", { digits: 0 }),
                ],
                ['*', '*', '*', '*', '*']
            ),
            h.panel(
                [
                    // prettier-ignore
                    h.row(
                        h.title("Total Brocados"),
                        h.title("Total Entrenós"),
                        h.title("Total Canas", { alignment: "right" }),
                    ),

                    // prettier-ignore
                    h.row(
                        h.numberField("totalBrocados"),
                        h.numberField("totalEntrenos"),
                        h.numberField("totalCanas", { digits: 0, alignment: "right" }),
                    ),
                ],
                { widths: ["*", "*", "*"] }
            ),

            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}
